import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#003087",
    margin: theme.spacing(1),
  },
  bookNowTitle: {
    color: "#003087",
    "margin-top": theme.spacing(10),
  },
}));

export default function FeatureNotAvailable() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom className={classes.bookNowTitle}>
        This feature is not available in your account (yet).
      </Typography>
      <Typography variant="h4" gutterBottom className={classes.title}>
        If you would like to enable it, get in touch with Julieth{" "}
        <span aria-label="teacher" role="img">
          💬
        </span>
      </Typography>
    </Container>
  );
}
